import React from 'react';
import styled from 'styled-components';

export const PICSPage: React.FC = () => {
  return (
    <PICSContainer>
      <h1>Personal Information Collection Statement</h1>
      <hr />
      <p>1. Purpose of Collection</p>
      <br />
      <p>{`The personal data provided by you to The Hong Kong Polytechnic University ("PolyU") during application for admission, (if admitted as students) during programme registration, throughout your studies and upon leaving PolyU will be used by PolyU for the following purposes:`}</p>
      <br />
      <p>
        <b>During application for admission</b>
      </p>
      <ul>
        <li>As basis for selection for admission;</li>
        <li>
          Managing your application account and processing your application with
          PolyU;
        </li>
        <li>
          Identifying possible multiple applications and obtaining records of
          your existing and previous studies and activities at PolyU and other
          institutions;
        </li>
        <li>Verifying your identity, qualifications and academic records;</li>
        <li>
          Conducting data analysis, research, surveys, quality assurance and
          review;
        </li>
        <li>Facilitating communications between you and PolyU;</li>
        <li>Other purposes directly relating to any of the above.</li>
      </ul>
      Upon your admission as a student of PolyU, your personal data provided
      during application will become part of your official student records. In
      case your application is not accepted, your personal data provided during
      application will be disposed of according to the prevailing policy of
      PolyU.
      <br />
      <br />
      <p>
        <b>During study and upon leaving PolyU</b>
      </p>
      <ul>
        <li>
          Processing your application for activities, services and facilities
          provided by units and departments of PolyU or organisations associated
          with PolyU;
        </li>
        <li>
          Processing the application and arrangement for study-related
          activities including but not limited to student visa, student exchange
          programmes, study tours, placement, internship, Service Learning &
          Work Integrated Education, training and scholarships, etc.
        </li>
        <li>
          Assisting your Academic advisor to provide support for students;
        </li>
        <li>Managing alumni affairs;</li>
        <li>
          Verifying student/graduate status, qualifications and academic
          records;
        </li>
        <li>{`Compiling the Graduates List for Congregation's use and disclosing information about your awards and
                                    achievements;`}</li>
        <li>
          Conducting data analysis, research, surveys, quality assurance and
          review;
        </li>
        <li>Facilitating communications between you and PolyU;</li>
        <li>Other purposes directly relating to any of the above.</li>
      </ul>
      <p>
        In case of application for admission to a programme jointly offered or
        collaborated by PolyU and its partner University/Institution(s), your
        personal data will be transferred to the partner
        University/Institution(s) for the above purposes. You are also required
        to provide an emergency contact, other than yourself, in case of
        emergency.
      </p>
      <hr />
      <p>
        2. You are required to provide your personal data, other than those
        items indicated as optional. In the absence of your personal data, we
        may not be able to process your application for admission, provide you
        with the requested activities, services or facilities or maintain
        contact with you.
      </p>
      <hr />
      <p>3. Disclosure and Transfer of Personal Data</p>
      <br />
      <p>
        PolyU will keep your personal data confidential and only authorised
        staff members of PolyU will have access to and handle your personal
        data. PolyU may disclose or transfer your personal data to the following
        parties within or outside Hong Kong solely for the purposes set out in
        paragraph 1 above.
      </p>
      <ul>
        <li>{`PolyU's student organisations and alumni organisations;`}</li>
        <li>
          Agencies, service providers, and contractors engaged in activities on
          behalf of PolyU;
        </li>
        <li>
          Other education institutions, their subsidiaries and relevant
          organizations, and government authorities in Hong Kong or other places
          for verification of qualifications you obtained from PolyU.
        </li>
      </ul>
      <p>
        PolyU may disclose your personal data when authorised or required by law
        and in response to requests from law enforcement agencies, government
        departments or regulatory authorities.
      </p>
      <hr />
      <p>4. Access and Correction of Personal Data</p>
      <br />
      <p>
        You have the right to request access and correction of your personal
        data held by PolyU. A fee may be imposed by PolyU for processing your
        data access request.
      </p>
      <p>
        During application for admission and your studies, correction of
        personal data can be performed via the relevant online platforms (i.e.
        RPgAdmission for applicants and eStudent for students). Any data access
        and correction request according to the Ordinance should be made by
        completing the{' '}
        <a href="https://www.polyu.edu.hk/ar/docdrive/polyu-students/eng-forms/DAR_Data-Access-Request-Form_PolyU-AR.pdf">
          Personal Data (Privacy) Ordinance Data Access Request Form
        </a>{' '}
        and sending it to the Graduate School at gs.admission@polyu.edu.hk.
      </p>
      <hr />
      <p>{`5. After graduation, correction of personal information can be done on "Contact Update" at
            https://www.polyu.edu.hk/alumni. Any data access and correction request according to the Ordinance should be
            made by completing the Personal Data (Privacy) Ordinance Data Access Request Form and sending it to the Alumni
            Affairs Office at alumni@polyu.edu.hk.`}</p>
      <hr />
      <p>6. Privacy Policy Statement</p>
      <br />
      <p>
        You may click{' '}
        <a href="https://www.polyu.edu.hk/privacy-policy-statement/">here</a>{' '}
        for the Privacy Policy Statement of PolyU.
      </p>
    </PICSContainer>
  );
};

const PICSContainer = styled.div`
  hr {
    margin: 10px 0;
  }
  ul {
    list-style: circle;
    margin-left: 2rem;
  }

  margin-left: 2rem;
  margin-right: 2rem;

  h1 {
    font-size: 2rem;
  }
`;
